import { useInsuranceEligibilityReportContainerContext } from '../../../../providers/insurance-report-container.provider';
import { InsuranceReportTable } from '../../../../shared/components/InsuranceReportTable';
import { useInsuranceReportAccordionContext } from '../../../../shared/context/AccordionContext';
import { useDentalInsuranceReportContext } from '../../context/DentalInsuranceReportDetailsContext.provider';
import { useInsuranceTableColumnFilters } from '../../hooks/useInsuranceTableColumnFilters';
import { TableDataType, Vendors } from '../../types/types';
import { InsuranceReportPrintableAccordionSection } from './InsuranceReportPrintableAccordionSection';
import { InsuranceSectionFilterContainer } from './InsuranceSectionFilterContainer';

export const ExclusionsTable = () => {
  const { locationId } = useInsuranceEligibilityReportContainerContext();
  const { tablesData, vendor } = useDentalInsuranceReportContext();
  const { isPrintReport } = useInsuranceReportAccordionContext();

  const { tableColumnsList, InsuranceReportTableColumnFilter } = useInsuranceTableColumnFilters({
    tableId: 'exclusions',
    isPrintReport,
    locationId,
  });

  if (isPrintReport) {
    return (
      <InsuranceReportPrintableAccordionSection
        tableId='exclusions'
        columns={tableColumnsList}
        vendor={vendor as Vendors}
      />
    );
  }

  return (
    <>
      <InsuranceSectionFilterContainer>{InsuranceReportTableColumnFilter}</InsuranceSectionFilterContainer>
      <InsuranceReportTable<TableDataType>
        tableInstanceId={`insurance-report-exclusions`}
        columns={tableColumnsList}
        tableData={tablesData?.exclusions || []}
        isPaginated={!isPrintReport}
      />
    </>
  );
};
